import Vue from "vue"
import VueMeta from "vue-meta"
import BootstrapVue from 'bootstrap-vue'

import App from "./App.vue"
import router from "./router"

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faSquare, faCalendar, faMapPin, faTags, faBug, faGlobe, faExclamation, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
  duration: 500,
  easing: "ease",
  offset: -120
})

library.add(
  faBars,
  faSquare,
  faCalendar,
  faMapPin,
  faTags,
  faBug,
  faLinkedin,
  faGlobe,
  faExclamation,
  faArrowLeft,
  faArrowRight
)

Vue.component('font-awesome', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(BootstrapVue)


// Vue addons
Vue.use(VueMeta)

new Vue({
  router,
  render: h => h(App),
  filters: {
    unescape: v => unescape(v)
  }
}).$mount("#app")
